import React, { Component } from "react"
import Utils from "../../../utils/node.utils"
import { Link } from "gatsby"
import WishlistButton from "../../Shared/WishlistButton/WishlistButton"

export default class Product extends Component {
  state = {
    product: {
      name: "",
      slug: "",
      data: {
        quantity: 1,
        price: {
          value: "0.00",
          currency: "EUR",
        },
      },
    },
  }

  componentDidMount() {
    const { product } = this.props
    let stateProduct = this.state.product

    stateProduct.id = product.id
    stateProduct.slug = product.slug
    stateProduct.name = Utils.GetContentKeyValue(product.content, "name")
    stateProduct.thumbnail = Utils.GetContentKeyValue(
      product.content,
      "thumbnails"
    )

    stateProduct.data.quantity = Utils.GetProductQuantity(product)
    stateProduct.data.price = Utils.GetProductPrice(product)

    this.setState({
      product: stateProduct,
    })
  }

  isOutOfStock = () => {
    const { product } = this.state
    return product.data.quantity === 0
  }

  hasDiscount = () => {
    const { product } = this.state
    if (!product.data.price || product.data.price.discount_value) {
      return !this.isOutOfStock()
    }
    return false
  }

  getSale = () => {
    const { contentMap } = this.props
    if (this.hasDiscount()) {
      return <div className="ribbon ribbon-pink">{contentMap.sale.value}</div>
    }
  }

  getPrice = () => {
    const { product } = this.state
    return Utils.GetDisplayPriceHor(product.data.price)
  }

  getOutOfStock = () => {
    const { contentMap } = this.props
    if (!this.isOutOfStock()) {
      return null
    }
    return (
      <div className="ribbon-outofstock ribbon-outofstock-color">
        {contentMap.out_of_stock.value}
      </div>
    )
  }

  getNew = () => {
    if (!this.props.new) {
      return null
    }
    return <div className="ribbon ribbon-info">New!</div>
  }

  getWishlistButton = () => {
    const { product, language, commonContentMap } = this.props
    return (
      <WishlistButton
        id={product.id}
        language={language}
        margin="ml-2"
        commonContentMap={commonContentMap}
      />
    )
  }

  reduceCategoriesToString = (categoryString, category) => {
    return categoryString.concat(
      " ",
      Utils.GetContentKeyValue(category.content, "name")
    )
  }

  getCategoryString = () => {
    const { product } = this.props
    if (!product.categories) {
      return ""
    }
    return product.categories.reduce(this.reduceCategoriesToString, "")
  }

  render() {
    const { product } = this.state
    const { breadCrumb, language, commonContentMap } = this.props
    const {
      getSale,
      getNew,
      getOutOfStock,
      getWishlistButton,
      getCategoryString,
    } = this

    const viewButtonContent = commonContentMap.button_view.value
    const title = viewButtonContent + " " + product.name
    const productLink = Utils.GetLanguageLink(
      language,
      "/shop/" + product.slug + "?breadcrumb=" + breadCrumb
    )

    return (
      <div className="col-xl-4 col-sm-6" id={product.id}>
        <div className="product">
          <div className="product-image text-center">
            {getSale()}
            {getNew()}
            {getOutOfStock()}
            <div className="ar-4-3">
              <img
                src={product.thumbnail}
                alt={product.name}
                title={product.name}
                className="img-fluid"
              />
            </div>
            <div className="product-hover-overlay">
              <Link
                to={productLink}
                title={title}
                className="product-hover-overlay-link"
                aria-label={viewButtonContent}
              ></Link>
              <div className="product-hover-overlay-buttons">
                {getWishlistButton()}
                <Link
                  to={productLink}
                  title={title}
                  className="btn btn-dark btn-buy overflow-hidden product-btn-size"
                >
                  <i className="fa-search fa" />
                  <span className="btn-buy-label ml-2">
                    {viewButtonContent}
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className="py-2">
            <p className="text-muted text-sm mb-1">{getCategoryString()}</p>
            <h3 className="h6 text-uppercase mb-1">
              <Link to={productLink} title={title} className="text-dark">
                {product.name}
              </Link>
            </h3>
            {this.getPrice()}
          </div>
        </div>
      </div>
    )
  }
}
